
export const GetProcessStatusList = [
    { text: "job_processing_inactive ", value: 0 },
    { text: "job_processing_active", value: 1 },
    { text: "job_processing_pausing", value: 2 },
    { text: "job_processing_paused", value: 3 }
]


